import isApiError from "@insite/client-framework/Common/isApiError";
import { HasOnComplete, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post, ServiceResult } from "@insite/client-framework/Services/ApiService";

export interface WebsiteFormApiParameter extends ApiParameter {
    uri?: string;
    firstName: string;
    lastName: string;
    companyName: string;
    customerNumber?: string;
    email: string;
    phone: string;
    fax?: string;
    website?: string;
    billingCountry: string;
    billingAddress?: string;
    billingCity?: string;
    province?: string;
    billingZip?: string;
    comments?: string;
    properties?: Properties;
    onError: (error: string) => void;
}

export interface Properties {}

export interface WebsiteFormResultModel {}

const websiteUrl = "/api/v2/existinguserregistration";

export async function websiteFormService(
    parameter: WebsiteFormApiParameter,
): Promise<ServiceResult<WebsiteFormResultModel>> {
    const apiParameter = { ...parameter };

    try {
        const result = await post<WebsiteFormResultModel>(websiteUrl, apiParameter);
        return {
            result,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
